export const MAPPED_EVENT = {
  click: 'Clicks',
  search: 'Searches',
  share: 'Share',
  ibl: 'Inbound Links',
  obl: 'Outbound Links',
  pview: 'Page Views',
  ecommerce_pview: 'Ecommerce Page Views',
  unknown: 'Other',
}

export const UIKIT_COLORS = {
  ds_pink_lightest: '#f8ebf3',
  ds_dark_green_2_lightest: '#ecf4f4',
  ds_dark_green_base: '#146a59',
  ds_green_five: '#ecf3ee',
  ds_green: '#13682b',
  ds_green_dark: '#0e4b1f',
  ds_blue: '#13682b',
  ds_blue_dark: '#098080',
  ds_blue_lightest: '#ecf9f9',
  ds_blue_five: '#ecf3ee',
  ds_pink_base: '#a40965',
  ds_purple_lightest: '#efecf6',
  ds_wine_lightest: '#f6eff3',
  ds_wine_dark: '#652a4e',
  ds_wine_light: '#b581a2',
  ds_gray: '#3d3d3d',
  dark_green_2: '#67A4A4',
  yellow_light: '#FAE8A4',
  pink_light: '#C5629C',
  blue_light: '#63CECE',
  purple_light: '#7D69B5',
}

export const UIKIT_COLORS_RGB = {
  ds_green_dark: [14, 75, 31],
}
